import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import ProcessOverview from './components/ProcessOverview';
import ProcessSteps from './components/ProcessSteps';
import OrderProgress from './components/OrderProgress';
import QualityAssurance from './components/QualityAssurance';

export default function HowItWorksPage() {
  return (
    <div className="min-h-screen bg-white">
      <main>
        <Hero />
        <ProcessOverview />
        <ProcessSteps />
        <OrderProgress />
        <QualityAssurance />
      </main>
      <Footer />
    </div>
  );
}